// extracted by mini-css-extract-plugin
export default {"technique":"Technique_technique__4wJbY","list":"Technique_list__fwNwj","item":"Technique_item__fkvgB"};